<template>
  <div>
    <div class="wwi-step-form">
      <wwi-page-header
        :step="4"
        :title="$t('pages.createaccount.title')"
        :description="$t('pages.createaccount.description')"
        :error="hasErrors ? $t('pages.createaccount.error') : ''"
      />
      <half-circle-spinner
        :animation-duration="1000"
        :size="100"
        color="#dc0046"
      />
    </div>
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'

export default {
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      userdata: null
    }
  },
  async mounted () {
    this.userdata = Object.assign({}, this.$store.getters['userdata/userdata'])
    this.userdata.contractor = this.$store.getters['general/contractor']
    await this.$store.dispatch('order/Order', this.userdata)
    if (!this.hasFormErrors) {
      this.$router.push('success')
    }
  }
}
</script>
